module.exports = __webpack_public_path__ + "media/images/joao-marcatto-df3176999c36e3b0cc777ccfc11dc15f.jpg";